$(function () {

	var __id = 0;

	function MkInputRange($range) {

		if (undefined === $range) {
			return this;
		}

		this.$range = $($range);
		this.$container = this.$range.closest('.mk-inputrange-container');
		this.$container = this.$container.length ? this.$container : this.$range.parent();
		this._config();

		this.$trigger = this._buildTrigger();
		this.$menu = this._buildMenu();
		this.bind();
	}

	MkInputRange.prototype = {

		_config: function () {
			this.isMenu = this.$range.attr('data-display') == 'menu';
			this.__id = 'mk-inputrange-owner-' + __id++;

			if (this.isMenu) {
				this.$range.css('display', 'none');
				this.$range.attr('aria-hidden', 'true');
			}
		},

		_buildTrigger: function () {

			if (this.isMenu) {

				var accessid = this.$container.attr('aria-describedby') || '',
					$trigger = $(
						'<a role="menubutton" aria-describedby="' + accessid + '" aria-expanded="false" aria-owns="' + this.__id + '" class="mk-inputrange-trigger" href="javascript: void(0);">' +
							'<span class="mk-inputrange-value">' + this.$range.find('.mk-inputrange-title').text() + '</span>' +
							'<span aria-hidden="true" class="icon" />' +
							'</a>');

				this.$container.append($trigger);
				return $trigger;
			}
			return null;
		},

		_buildMenu: function () {

			if (this.isMenu) {
				var id = this.__id, counter = 0,
					$inputs = this.$range.find('.mk-inputrange-item'),
					$menu = $('<ul id="' + id + '" class="mk-inputrange-menu default" />'),
					$li;

				$inputs.each(function () {
					$li = $('<li class="mk-inputrange-item" id="' + (id) + '-descendant-' + (counter++) + '">');
					$li.append(this);
					$menu.append($li);
				});

				this.$container.append($menu);
				return $menu;
			}
			return null;
		},

		_isOpened: function () {
			return this.$trigger.attr('aria-expanded') === 'true';
		},

		_keySpace: function (e) {
			e.preventDefault();
			if (!this._isOpened()) {
				this.$trigger.trigger('click.mk-inputrange');
			}
		},

		_validateInput: function (e, $input) {

			var reg = $input.attr('data-validate') || '',
				val = $input.val();

			if (reg) {
				var regEx = new RegExp(reg, 'g'),
					matches = val.match(regEx);

				$input.val(matches && matches.join('') || '');
			}
		},

		bind: function () {
			var self = this;
			this.$container.find('input:text').on('keyup.mk-inputrange', function (e) {

				var $input = $(this),
					timer = $input.data('timer') || null;

				if (timer) {
					clearTimeout(timer);
					timer = $input.data('timer', null);
				}

				timer = setTimeout(function () {
					self._validateInput(e, $input);
				}, 100);

				$input.data('timer', timer);
			});

			if (this.isMenu) {

				var self = this;

				this.$trigger.on('click.mk-inputrange', function (e) {

					e.preventDefault();

					if (self.$menu.hasClass('default')) {
						self.$menu.removeClass('default');
						self.$trigger.attr('aria-expanded', 'true');
						return;
					}
					self.$menu.addClass('default');
					self.$trigger.attr('aria-expanded', 'false');
				});

				this.$trigger.on('focus.mk-inputrange', function () {
					self.$trigger.on('keydown.mk-inputrange', function (e) {
						switch (e.which) {
							case 32:
								self._keySpace(e);
								break;
						}
					});
						
					self.$trigger.one('blur.mk-inputrange', function (e) {
						self.$trigger.off('keydown.mk-inputrange');
					});
				});

				$(document.body).on('click.mk-inputrange', function (e) {

					var $t = $(e.target);

					if (($t.is(self.$trigger) || $t.closest('.mk-inputrange-trigger').length) ||
						($t.is(self.$menu) || $t.closest('.mk-inputrange-menu').length)) {
						return;
					}

					if (!self.$menu.hasClass('default')) {
						self.$menu.addClass('default');
						self.$trigger.attr('aria-expanded', 'false');
					}
				});
			}
		}
	};

	jQuery.fn.mkinputrange = function () {
		return this.each(function () {
			var $el = $(this);
			$el.data('mk-inputrange', $el.data('mk-inputrange') || new MkInputRange($el));
		});
	};

	jQuery.Fed = jQuery.Fed || {};
	jQuery.Fed.MkInputRange = MkInputRange;

	$(function () {
		$('.mk-inputrange').mkinputrange();

		$(document).on('loaded', function (event) {
			$(event.target)
				.find('.mk-inputrange')
				.each(function (i, menu) {
					$(menu).mkinputrange();
				});
		});
	});
});